import { GET_API, PATCH_API } from "../../../Functionalities/APIs";
import { fullMediaUrl } from "../../../Functionalities/fullMediaUrl";

const HOME_PATH = "/items/home/";
const UNREACHABLE = "Could not reach the server. Try again.";

export const fetchHomeTiles = async (franchise) => {
  const { latitude, longitude } = franchise || {};
  if (latitude == null || longitude == null) return [];
  const result = await GET_API("", `latitude=${latitude}&longitude=${longitude}`, HOME_PATH);
  const categories = (result && result.data && result.data.categories) || [];
  return categories.map((tile) => ({ ...tile, image: fullMediaUrl(tile.image) }));
};

export const saveUmbrellaImage = async (umbrellaId, file) => {
  const form = new FormData();
  form.append("image", file);
  const result = await PATCH_API(form, "", `/items/categories/umbrellas/${umbrellaId}/`);
  const reply = result && result.data;
  if (!reply) return { error: UNREACHABLE };
  return reply.Status ? { ok: true } : { error: reply.Error || reply.Message || UNREACHABLE };
};
